import { render, staticRenderFns } from "./EnrichmentPlot.vue?vue&type=template&id=51918336&scoped=true"
import script from "./EnrichmentPlot.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrichmentPlot.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EnrichmentPlot.vue?vue&type=style&index=0&id=51918336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51918336",
  null
  
)

export default component.exports